import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import router from './router'
//import { stat } from 'fs';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appTitle: "Mentor Directory",
    includeCoach: false,
    userName: null,
    userEmail: null,
    userUID: null,
    myProfile: {},
    chosenProfile: {},
    authorised: null,
    allRelationships: [],
    myRelationships: [],
    myMentorRelationships: [],
    myClientRelationships: [],
    mentors: [],
    mentorRoles: [],
    mentorTopics: [],
    clients: [],
    configData: {},
    adminEmail: {},
    storeLoading: false,
    mentorLoading: false,
    clientLoading: false,
    progressColour: "white",
    errorMessage: {
      display: false,
      color: "error",
      message: null
    },
    configEditMode: false,
    profileEditMode: false,
    acceptanceMsg: false,
    // privacyPolicy: "<p>When you register we will ask you for information about your role, location, research background and areas of research interest.  We will use this information and share it with other Directory users for the purpose of matching potential mentors and clients.  We will maintain records of connections made and the status of ongoing mentoring relationships, but not ask for details of any mentoring discussions. We may use your contact data to follow up with you about the use of the application.</p><p>You can edit the information you give us at any time. You can also delete the information about you held in the Directory by emailing <a href='mailto:nenclearning@nihr.ac.uk' target='_blank'>nenclearning@nihr.ac.uk</a>.</p>",
    privacyPolicy: {},
    welcomeText: {}
  },
  getters: {
    getAppTitle: state => {
      return state.appTitle
    },
    getIncludeCoach: state => {
      return state.includeCoach
    },
    getUserName: state => {
      return state.userName
    },
    getUserEmail: state => {
      return state.userEmail
    },
    getUserUID: state => {
      return state.userUID
    },
    getMyProfile: state => {
      return state.myProfile
    },
    getChosenProfile: state => {
      return state.chosenProfile
    },
    getAuthorisedFlag: state => {
      return state.myProfile.authorised
    },
    getAdminFlag: state => {
      return state.myProfile.admin
    },
    getSystemAdminFlag: state => {
      return state.myProfile.systemAdmin
    },
    getConfig: state => {
      return state.configData
    },
    getAdminEmail: state => {
      return state.adminEmail
    },
    getStoreLoading: state => {
      return state.storeLoading
    },
    getProgressColour: state => {
      return state.progressColour
    },
    getMentorLoading: state => {
      return state.mentorLoading
    },
    getClientLoading: state => {
      return state.clientLoading
    },
    getErrorMessage: state => {
      return state.errorMessage
    },
    getConfigEditMode: state => {
      return state.configEditMode
    },
    getProfileEditMode: state => {
      return state.profileEditMode
    },
    getAllMentors: state => {
      return state.mentors
    },
    getMentors: state => {
      return state.mentors.filter(mentor => mentor.email != state.userEmail &&
                                  mentor.authorised == true &&
                                  mentor.available != "Unavailable" &&
                                  Number(mentor.clientsCurrent) < Number(mentor.clientsLimit))
    },
    getAllClients: state => {
      return state.clients
    },
    getMyMentors: state => {
      return state.myMentorRelationships
    },
    getAllRelationships: state => {
      return state.allRelationships
    },
    getMyClients: state => {
      return state.myClientRelationships
    },
    getAcceptanceMsg: state => {
      return state.acceptanceMsg
    },
    getPrivacyPolicy: state => {
      return state.privacyPolicy
    },
    getWelcomeText: state => {
      return state.welcomeText
    }
  },
  mutations: {
    setAppTitle(state, payload) {
      state.appTitle = payload
    },
    setIncludeCoach(state, payload) {
      state.includeCoach = payload
    },
    setUserName(state, payload) {
      state.userName = payload
    },
    setUserEmail(state, payload) {
      state.userEmail = payload
    },
    setUserUID(state, payload) {
      state.userUID = payload
    },
    setProfile(state, payload) {
      state.myProfile = payload
    },
    setChosenProfile(state, payload) {
      state.chosenProfile = payload
    },
    incrementMyClients(state) {
      ++state.myProfile.clientsCurrent
    },
    decrementMyClients(state) {
      --state.myProfile.clientsCurrent
    },
    setConfig(state, payload) {
      state.configData = payload
    },
    setAdminEmail(state, payload) {
      state.adminEmail = payload
    },
    setStoreLoading(state, payload) {
      state.storeLoading = payload
    },
    setProgressColour(state, payload) {
      state.progressColour = payload
    },
    setMentorLoading(state, payload) {
      state.mentorLoading = payload
    },
    setClientLoading(state, payload) {
      state.clientLoading = payload
    },
    showErrorMessage(state, payload) {
      state.errorMessage.display = true,
      state.errorMessage.color = payload.color,
      state.errorMessage.message = payload.message
    },
    clearErrorMessage(state) {
      state.errorMessage.display = false,
      state.errorMessage.color = null,
      state.errorMessage.message = null
    },
    setConfigEditMode(state, payload) {
      state.configEditMode = payload
    },
    setProfileEditMode(state, payload) {
      state.profileEditMode = payload
    },
    setAuthorised(state, payload) {
      state.authorised = payload
    },
    pushMentor(state,payload) {
      state.mentors.push(payload)
    },
    setMentors(state,payload) {
      state.mentors = payload
    },
    setClients(state,payload) {
      state.clients = payload
    },
    setMyMentors(state,payload) {
      state.myMentorRelationships = payload
    },
    setAllRelationships(state,payload) {
      state.allRelationships = payload
    },
    setMyClients(state,payload) {
      state.myClientRelationships = payload
    },
    clearMyClients(state) {
      state.myClientRelationships.length = 0
    },
    setAcceptanceMsg(state, payload) {
      state.acceptanceMsg = payload
    },
    setPrivacyPolicy(state, payload) {
      state.privacyPolicy = payload
    },
    setWelcomeText(state, payload) {
      state.welcomeText = payload
    }
  },
  actions: {
    updateUserName: (context, payload) => {
      context.commit('setUserName', payload)
    },
    updateUserEmail: (context, payload) => {
      context.commit('setUserEmail', payload)
    },
    autoSignIn (context, payload) {
      console.log('Store - AutoSignIn:' + payload.name)
      context.commit('setUserName', payload.name)
      context.commit('setUserEmail', payload.email)
      context.commit('setUserUID', payload.uid)
      //OK they've signed in so lets check if they are authorised to access the data
      context.dispatch('checkAuthorised')
      //context.dispatch('updateConfig')
    },
    userSignOut (context) {
      firebase.auth().signOut()
      context.dispatch('updateUserName', null)
      context.dispatch('updateUserEmail', null)
      router.push('/')
    },
    updateConfig(context) {
      //activate the progress bar
      context.commit('setProgressColour',"white")
      context.commit('setStoreLoading',true)
      //get config data from firebase
      //Retrieve the app config document from the 'mentorConfig' collection in firebase.firestore
      firebase.firestore().collection('mentorConfig').doc('config').get()
      .then(doc => {
        if (doc.exists) {
          var configdata = doc.data()
          console.log("Config Data",configdata)

          context.commit('setConfig',configdata)
          //de-activate the progress bar
          context.commit('setStoreLoading',false)
        } else {
          console.log("Store - Error getting config data. Doc does not exist.");
          //de-activate the progress bar
          //context.commit('setStoreLoading',false)
        }
      })
      .catch(error => {
        console.log("Store - Error getting config data:", error);
        //de-activate the progress bar
        //context.commit('setStoreLoading',false)
      });
    },
    updateAppTitle(context) {
      //get App Title data from firebase
      //Retrieve the appTitle document from the 'mentorConfig' collection in firebase.firestore
      firebase.firestore().collection('mentorConfig').doc('appTitle').get()
      .then(doc => {
        if (doc.exists) {
          var configdata = doc.data()
          console.log("App Title Data",configdata)

          context.commit('setAppTitle',configdata.title)

          if (configdata.title.toUpperCase().includes('COACH')) {
            context.commit('setIncludeCoach',true)
          } else {
            context.commit('setIncludeCoach',false)
          }
          
        } else {
          console.log("Store - Error getting appTitle data. Doc does not exist.");
        }
      })
      .catch(error => {
        console.log("Store - Error getting appTitle data:", error);
      });
    },
    saveConfig(context, payload) {
      //activate the progress bar
      context.commit('setProgressColour',"green")
      context.commit('setStoreLoading',true)
      firebase.firestore().collection('mentorConfig').doc('config').set(payload)
      .then(function() {
        console.log("Store - Success saving new config data to firebase")

        //update the store's version of the config data too
        context.commit('setConfig',payload)

        //de-activate the progress bar
        context.commit('setStoreLoading',false)
        context.commit('showErrorMessage',{color:"success",message:"Configuration data successfully updated."})
        context.commit('setConfigEditMode',false)
      })
      .catch(error => {
        console.log("Store - Error saving new config data to firebase",error)
        //de-activate the progress bar
        context.commit('setStoreLoading',false)
        context.commit('showErrorMessage',{color:"error",message:"There was a problem updating the configuration data."})
      })
    },
    updateAdminEmail(context) {
      //activate the progress bar
      context.commit('setProgressColour',"white")
      context.commit('setStoreLoading',true)
      //get config data from firebase
      //Retrieve the app config document from the 'mentorConfig' collection in firebase.firestore
      firebase.firestore().collection('mentorConfig').doc('adminEmail').get()
      .then(doc => {
        if (doc.exists) {
          var configdata = doc.data()
          console.log("Admin Email Data",configdata)

          context.commit('setAdminEmail',configdata)
          //de-activate the progress bar
          context.commit('setStoreLoading',false)
        } else {
          console.log("Store - Error getting admin email data. Doc does not exist.");
          //de-activate the progress bar
          //context.commit('setStoreLoading',false)
        }
      })
      .catch(error => {
        console.log("Store - Error getting admin email data:", error);
        //de-activate the progress bar
        //context.commit('setStoreLoading',false)
      });
    },
    saveAdminEmail(context, payload) {
      //activate the progress bar
      context.commit('setProgressColour',"green")
      context.commit('setStoreLoading',true)
      firebase.firestore().collection('mentorConfig').doc('adminEmail').set(payload)
      .then(function() {
        console.log("Store - Success saving new adminEmail data to firebase")

        //update the store's version of the config data too
        context.commit('setAdminEmail',payload)

        //de-activate the progress bar
        context.commit('setStoreLoading',false)
        context.commit('showErrorMessage',{color:"success",message:"Admin email data successfully updated."})
        context.commit('setConfigEditMode',false)
      })
      .catch(error => {
        console.log("Store - Error saving new admin email data to firebase",error)
        //de-activate the progress bar
        context.commit('setStoreLoading',false)
        context.commit('showErrorMessage',{color:"error",message:"There was a problem updating the admin email data."})
      })
    },
    saveMyProfile(context, payload) {
      //activate the progress bar
      context.commit('setProgressColour',"yellow")
      context.commit('setStoreLoading',true)
      console.log("Store - Profile payload ", payload)
      firebase.firestore().collection('profiles').doc(context.state.userUID).set(payload)
      .then(function() {
        console.log("Store - Success saving my profile data to firebase")

        //update the store's version of the config data too
        context.commit('setProfile',payload)

        //de-activate the progress bar
        context.commit('setStoreLoading',false)
        if (router.currentRoute.name == 'userProfile') {
          if ((payload.hasOwnProperty("convertRequest")) && (payload.mentor == false)) {
            context.commit('showErrorMessage',{color:"success",message:"Your request to become a mentor has been submitted."})  
          } else {
            context.commit('showErrorMessage',{color:"success",message:"Profile data successfully updated."})
          }
          context.commit('setProfileEditMode',false)
          console.log("Store - Profile Edit Mode = ",context.state.profileEditMode)
        }
        //if the profile was saved from the notAuth page log the user out.
        if (router.currentRoute.name == 'notauth') {
          firebase.auth().signOut()
          .then(() => {
            console.log("Store - Un-Authorised User Logged Out!")
          })
        }

      })
      .catch(error => {
        console.log("Store - Error saving profile data to firebase",error)
        //de-activate the progress bar
        context.commit('setStoreLoading',false)
        context.commit('showErrorMessage',{color:"error",message:"There was a problem updating the profile data."})
      })
    },
    saveAuthChange(context, payload) {
      //activate the progress 
      context.commit('setMentorLoading',true)
      
      firebase.firestore().collection('profiles').doc(payload.uid).update(payload)
      .then(function() {
        console.log("Store - Success updating auth for ", payload.email)

        //update the store's version of the users
        context.dispatch('updateMentors')
        context.dispatch('updateClients')

        //de-activate the progress bar
        context.commit('setMentorLoading',false)
        context.commit('showErrorMessage',{color:"success",message:"User's authorisation successfully updated."})
      })
      .catch(error => {
        console.log("Store - Error updating user's authorisation in firebase",error)
        //de-activate the progress bar
        context.commit('setMentorLoading',false)
        context.commit('showErrorMessage',{color:"error",message:"There was a problem updating the user's authorisation."})
      })
    },
    /*
    checkAuthorised (context) {
      //retrieve the user's document from the profiles collection
      //to prove they are authorised to access the data
      firebase.firestore().collection('users').doc(context.state.userEmail).get()
      //firebase.firestore().collection('profiles').doc(context.state.userUID).get()
      .then(doc => {
        if (doc.exists) {
          console.log("Store - User has profile doc")
          //user has a document in the users collection in the database
          //now check if they have been explicitly authorised to use the app by an administrator
          //if so - set the authorised flag to true
          
          //var userData = doc.data()
          context.commit('setProfile',doc.data())
          //console.log("Store - Debug 1")

          if (context.state.myProfile.authorised) {
            //as the user is authorised now we can retrieve the config data
            context.dispatch('updateAppTitle')
            context.dispatch('updateConfig')
            context.dispatch('updateAdminEmail')
            context.dispatch('updateWelcomeText')
            context.dispatch('updatePrivacyPolicy')
          } else {
            //the user isn't authorised yet so we need to send them to the notAuth page
            context.dispatch('updateAuthorised', false)
          }
        } else {
          //user does not have a document in the users collection in the database
          //so has not been authorised to use the app
          context.dispatch('updateAuthorised', false)
        }
      })
      .catch(error => {
        console.log("Store - Error getting user doc:", error.code);
        if (error.code == "permission-denied") {
          //user has not been authorised in the app
          context.dispatch('updateAuthorised', false)
        } else if (error.code == "unavailable") {
          context.dispatch('updateNoData', true)
        } else {
          //it's an unexpected error so write it out to the console
          console.log("Store - Unexpected error getting user doc:", error);
        }
      });
    },
    */
    ///////

    async checkAuthorised (context) {

      try {
        //retrieve the user's document from the profiles collection
        //to prove they are authorised to access the data
        var profileDoc = await firebase.firestore().collection('profiles').doc(context.state.userUID).get();
        var userDoc = await firebase.firestore().collection('users').doc(context.state.userEmail).get();

        var userProfile

        if (profileDoc.exists) {
          userProfile = profileDoc.data()
        } else if (userDoc.exists) {
          userProfile = userDoc.data()
        }

        if (userProfile) {
          //user has a document in the users collection in the database
          //now check if they have been explicitly authorised to use the app by an administrator
          //if so - set the authorised flag to true
          
          //var userData = doc.data()
          context.commit('setProfile',userProfile)
          console.log("Store - Debug 1")

          if (context.state.myProfile.authorised) {
            //as the user is authorised now we can retrieve the config data
            context.dispatch('updateAppTitle')
            context.dispatch('updateConfig')
            context.dispatch('updateAdminEmail')
            context.dispatch('updateWelcomeText')
            context.dispatch('updatePrivacyPolicy')
          } else {
            //the user isn't authorised yet so we need to send them to the notAuth page
            console.log("Store - User's profile/user doc has not been authorised")
            context.dispatch('updateAuthorised', false)
          }
        } else {
          //user does not have a document in the profiles or users collection in the database
          //so has not been authorised to use the app
          context.dispatch('updateAuthorised', false)
        }
      } catch(error) {
        console.log("Store - Error getting user doc:", error.code);
        if (error.code == "permission-denied") {
          //user has not been authorised in the app
          context.dispatch('updateAuthorised', false)
        } else if (error.code == "unavailable") {
          context.dispatch('updateNoData', true)
        } else {
          //it's an unexpected error so write it out to the console
          console.log("Store - Unexpected error getting user doc:", error);
        }
      };
    },

    //////
    updateAuthorised (context, payload) {
      context.commit('setAuthorised', payload)
      console.log('Store - Authorised: ' + context.state.authorised)
      //if the user is not authorised redirect them to the Not Authorised page
      if(!context.state.authorised) {
        console.log("Store - Unauthorised User Name ", context.state.userName)
        router.push('/notauth')
      }
    },
    updateMentors (context) {
      //display progress 
      context.commit('setMentorLoading',true)
      var tmpMentors = []
      //retrieve all the user documents where the mentor flag is set to true
      firebase.firestore().collection('profiles').where("mentor","==",true)
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          //add the mentor into the temp array of mentors
          tmpMentors.push({...doc.data(),id: doc.id})
          //context.commit('pushMentor',doc.data())
        })
        //set the store mentors equal to the tmpMentors array
        context.commit('setMentors',tmpMentors)
        console.log("Store - All Mentors ", context.state.mentors)
        //hide progress
        context.commit('setMentorLoading',false)
      })
      .catch(function(error) {
        console.log("Store - unexpected error retrieving mentors", error)
        //hide progress
        context.commit('setMentorLoading',false)
        //display error message
        context.commit('showErrorMessage',{color:"error",message:"There was a problem retrieving the mentor information."})
      })
    },
    updateClients (context) {
      //display progress dialog
      //context.commit('setProgressColour',"orange")
      context.commit('setClientLoading',true)
      var tmpClients = []
      //retrieve all the user documents where the mentor flag is set to false
      firebase.firestore().collection('profiles').where("mentor","==",false)
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          //add the client into the temp array of clients
          tmpClients.push({...doc.data(),id: doc.id})
          //context.commit('pushClient',doc.data())
        })
        //set the store clients equal to the tmpClients array
        context.commit('setClients',tmpClients)
        //hide progress dialog
        context.commit('setClientLoading',false)
      })
      .catch(function(error) {
        console.log("Store - unexpected error retrieving clients", error)
        //hide progress dialog
        context.commit('setClientLoading',false)
        //display error message
        context.commit('showErrorMessage',{color:"error",message:"There was a problem retrieving the client information."})
      })
    },
    createRelationship (context, payload) {
      //activate the progress bar
      context.commit('setProgressColour',"purple")
      context.commit('setStoreLoading',true)

      //save the payload (relationshipRequest) to the relationships collection in firestore
      firebase.firestore().collection('relationships').add(payload)
      .then(function() {
        console.log("Store - Success adding relationship to firebase")

        //update the store's version of the user's relationships
        //context.commit('setProfile',payload)

        //de-activate the progress bar
        context.commit('setStoreLoading',false)
        context.commit('showErrorMessage',{color:"success",message:"Relationship request submitted."})
        context.commit('setProfileEditMode',false)
      })
      .catch(error => {
        console.log("Store - Error adding relationship to firebase",error)
        //de-activate the progress bar
        context.commit('setStoreLoading',false)
        context.commit('showErrorMessage',{color:"error",message:"There was a problem submitting your relationship request."})
      })
    },
    updateMyMentors (context) {
      //display progress 
      context.commit('setMentorLoading',true)
      var tmpMentors = []
      //retrieve all the relationship documents where the current user is the client
      firebase.firestore().collection('relationships').where("client.email","==",context.state.userEmail)
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          //data() doesn't include the Form Id so copy data to a tmp object
          var tmpObject = doc.data()
          //Get and add the formId to tmpObject - need the form id
          //so that the correct 'Responses' collection can be updated
          tmpObject.formId = doc.id

          //add the mentor into the temp array of mentors
          tmpMentors.push(tmpObject)
        })
        //set the store mentors equal to the tmpMentors array
        context.commit('setMyMentors',tmpMentors)
        //console.log("Store - My Mentors ", context.state.myMentorRelationships)
        //hide progress
        context.commit('setMentorLoading',false)
      })
      .catch(function(error) {
        console.log("Store - unexpected error retrieving mentors", error)
        //hide progress
        context.commit('setMentorLoading',false)
        //display error message
        context.commit('showErrorMessage',{color:"error",message:"There was a problem retrieving the mentor information."})
      })
    },
    updateMyClients (context) {
      //display progress 
      context.commit('setClientLoading',true)
      context.commit('clearMyClients')
      var tmpClients = []
      //retrieve all the relationship documents where the current user is the mentor
      firebase.firestore().collection('relationships').where("mentor.email","==",context.state.userEmail)
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          //data() doesn't include the Form Id so copy data to a tmp object
          var tmpObject = {}
          tmpObject = doc.data()
          //Get and add the formId to tmpObject - need the form id
          //so that the correct 'Relationship' doc can be updated
          tmpObject.formId = doc.id
          //add the client into the temp array of clients
          tmpClients.push(tmpObject)
        })
        //set the store clients equal to the tmpClients array
        context.commit('setMyClients',tmpClients)
        //console.log("Store - My Clients ", context.state.myClientRelationships)
        //hide progress
        context.commit('setClientLoading',false)
      })
      .catch(function(error) {
        //console.log("Store - unexpected error retrieving mentors", error)
        //hide progress
        context.commit('setClientLoading',false)
        //display error message
        context.commit('showErrorMessage',{color:"error",message:"There was a problem retrieving the mentor information."})
      })
    },
    updateAllRelationships (context) {
      //display progress 
      context.commit('setMentorLoading',true)
      var tmpRelationships = []
      //retrieve all the relationship documents
      firebase.firestore().collection('relationships')
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          //data() doesn't include the Form Id so copy data to a tmp object
          var tmpObject = doc.data()
          //Get and add the formId to tmpObject - need the form id
          //so that the correct 'Responses' collection can be updated
          tmpObject.formId = doc.id

          //add the mentor into the temp array of mentors
          tmpRelationships.push(tmpObject)
        })
        //set the store mentors equal to the tmpMentors array
        context.commit('setAllRelationships',tmpRelationships)
        console.log("Store - All Relationships ", context.state.allRelationships)
        //hide progress
        context.commit('setMentorLoading',false)
      })
      .catch(function(error) {
        console.log("Store - unexpected error retrieving relationships", error)
        //hide progress
        context.commit('setMentorLoading',false)
        //display error message
        context.commit('showErrorMessage',{color:"error",message:"There was a problem retrieving the relationship information."})
      })
    },
    changeRelationshipStatus(context, payload) {
      console.log("Store - changeRelationshipStatus payload id ",payload.formId)
      //activate the progress 
      context.commit('setMentorLoading',true)
      
      firebase.firestore().collection('relationships').doc(payload.formId).update(payload)
      .then(function() {
        console.log("Store - Success updating relationship for ", payload.mentor.email)

        //update the store's version of the users
        //context.dispatch('updateMyMentors')
        context.dispatch('updateMyClients')

        //de-activate the progress bar
        context.commit('setMentorLoading',false)
        context.commit('showErrorMessage',{color:"success",message:"Relationship status successfully updated."})

        //if it was a change to active then display a message to the user
        if (payload.relationshipStatus == 'active' || payload.relationshipStatus == 'complete') {
          // increment/decrement the clientsCurrent field on the mentor's profile
          if (payload.relationshipStatus == 'active') {
            context.commit('incrementMyClients')
          } else {
            context.commit('decrementMyClients')
          }
          //now save the change to firestore
          context.dispatch('saveMyProfile',context.state.myProfile)
          
          if (payload.relationshipStatus == 'active') {
            context.commit('setAcceptanceMsg',true)
          }
        }
        
      })
      .catch(error => {
        console.log("Store - Error accepting client",error)
        //de-activate the progress bar
        context.commit('setMentorLoading',false)
        context.commit('showErrorMessage',{color:"error",message:"There was a problem updating the relationship status."})
      })
    },
    saveRelationship(context, payload) {
      console.log("Store - saveRelationship payload id ",payload.formId)
      //activate the progress 
      context.commit('setMentorLoading',true)
      
      firebase.firestore().collection('relationships').doc(payload.formId).update(payload)
      .then(function() {
        console.log("Store - Success updating relationship for ", payload.mentor.email)

        //update the store's version of the users
        //context.dispatch('updateMyMentors')
        context.dispatch('updateMyClients')

        //de-activate the progress bar
        context.commit('setMentorLoading',false)
        context.commit('showErrorMessage',{color:"success",message:"Relationship successfully updated."})
      })
      .catch(error => {
        console.log("Store - Error accepting client",error)
        //de-activate the progress bar
        context.commit('setMentorLoading',false)
        context.commit('showErrorMessage',{color:"error",message:"There was a problem updating the relationship."})
      })
    },
    updateChosenProfile(context, payload) {
      console.log("Store - updateChosenProfile - ",payload)
      // retrieve the user document with the email passed in the payload (there should only be one)
      return new Promise((resolve, reject) =>{
        firebase.firestore().collection('profiles').where("email", "==", payload)
        .get()
        .then((querySnapshot) =>{
          if (!querySnapshot.empty) {
            //We know there is one doc in the querySnapshot
            const queryDocumentSnapshot = querySnapshot.docs[0];
            context.commit('setChosenProfile',queryDocumentSnapshot.data())
            resolve(queryDocumentSnapshot.id)
          }
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    updateWelcomeText(context) {
      // Retrieve the welcome text from the 'mentorConfig/welcomeText' document in firebase.firestore
      firebase.firestore().collection('mentorConfig').doc('welcomeText').get()
        .then(doc => {
          if (doc.exists) {
            // var policyData = doc.data()
            context.commit('setWelcomeText', doc.data())
          } else {
            console.log('Store - Error getting Welcome Text, no such document.')
          }
        })
        .catch(error => {
          console.log('Store - Error getting Welcome Text: ', error)
        }) // end get privacy policy
    },
    saveWelcomeText(context, payload) {
      // Retrieve the policy from the 'presconfig/welcomeText' document in firebase.firestore
      firebase.firestore().collection('mentorConfig').doc('welcomeText').set(payload)
        .then(() => {
          context.commit('setWelcomeText', payload)
        })
        .catch(error => {
          console.log('Store - Error saving Welcome Text: ', error)
        }) // end
    },
    updatePrivacyPolicy(context) {
      // Retrieve the welcome text from the 'mentorConfig/privacy' document in firebase.firestore
      firebase.firestore().collection('mentorConfig').doc('privacy').get()
        .then(doc => {
          if (doc.exists) {
            // var policyData = doc.data()
            context.commit('setPrivacyPolicy', doc.data())
          } else {
            console.log('Store - Error getting Privacy Policy, no such document.')
          }
        })
        .catch(error => {
          console.log('Store - Error getting Welcome Text: ', error)
        }) // end get privacy policy
    },
    savePrivacyPolicy(context, payload) {
      // Retrieve the policy from the 'presconfig/privacy' document in firebase.firestore
      firebase.firestore().collection('mentorConfig').doc('privacy').set(payload)
        .then(() => {
          context.commit('setPrivacyPolicy', payload)
        })
        .catch(error => {
          console.log('Store - Error saving Privacy Policy: ', error)
        }) // end
    }
  }
})
